<section class="location-map-card" aria-label="Haritadan konum seçimi">
  <header class="location-map-header">
    <div><h2>Konum Seçimi</h2><p>Konumu belirlemek için haritaya tıklayın.</p></div>
    <span class="offline-badge"><span></span>OFFLINE</span>
  </header>
  <div class="location-map-body">
    <div #mapElement class="location-map-canvas" [style.height.px]="height" tabindex="0" aria-label="Dünya haritası. Sürükleyerek taşıyın, yakınlaştırın ve konum seçmek için tıklayın."></div>
    <div class="map-controls" aria-label="Harita kontrolleri">
      <button type="button" (click)="zoomIn()" aria-label="Yakınlaştır" title="Yakınlaştır">+</button>
      <button type="button" (click)="zoomOut()" aria-label="Uzaklaştır" title="Uzaklaştır">−</button>
      <button type="button" (click)="resetView()" aria-label="Dünya görünümü" title="Dünya görünümü">⌂</button>
    </div>
    <span class="map-attribution">Natural Earth · HDX/OCHA (CC BY-IGO)</span>
  </div>
  <footer class="location-map-footer" aria-live="polite">
    <div><span>Enlem / Latitude</span><strong>{{ selectedLocation ? (selectedLocation.Latitude | number:'1.6-6':'en-US') : '—' }}</strong></div>
    <div><span>Boylam / Longitude</span><strong>{{ selectedLocation ? (selectedLocation.Longitude | number:'1.6-6':'en-US') : '—' }}</strong></div>
    <span class="selection-hint">{{ selectedLocation ? 'Konum seçildi' : 'Seçim bekleniyor' }}</span>
  </footer>
</section>
